export const formatToRu = (i: number) => new Intl.NumberFormat('ru-RU').format(i);

export const roundNumber = (number: number, decimals: number) => {
  const h = 10 ** decimals;
  return Math.round(number * h) / h;
};
